import { Injectable } from '@angular/core';

@Injectable()
export class SettlementReportFilter {
  public _settlementReportFilter : any [] = [
    {value:1, name : 'Fecha de Liquidación'},
    {value:2, name : 'Fecha de Transferencia'}
  ]
}